<template>
    <IndexHeader />
    <HeaderImage />
    <NewsNav />
    <NewsList />
    <HomePageFooter />
</template>

<script>
// 首页顶部导航栏
import IndexHeader from "../components/IndexHeader/TopBar";
// 顶部大图
import HeaderImage from "../components/NewsCenter/HeaderImage";
// 面包屑导航
import NewsNav from "../components/NewsCenter/NewsNav";
// 新闻列表
import NewsList from "../components/NewsCenter/NewsList";
// 首页底部Footer
import HomePageFooter from "../components/HomePageFooter/Footer";

export default {
    name: "NewsCenterPage",
    components: {
        IndexHeader,
        HeaderImage,
        NewsNav,
        NewsList,
        HomePageFooter
    },
}
</script>